(function ($, Global) {
	var FormUnsubscribeComponent = function (model) {
		this.model = model;
	}

	FormUnsubscribeComponent.prototype.initEvents = function () {
		this.publishers();
	}

	FormUnsubscribeComponent.prototype.publishers = function () {
        var self = this;

        $(document).ready(handleStateSubmitButton);

		$(document).on('submit', '.form-unsub', function (e) {
			e.preventDefault();

			var $this = $(this);
			var data = $this.serializeJson();

			self.model.unsubscribe(data, function () {
				$('div.section-unsub').toggleClass("hidden");
			});
        });
    }

    function handleStateSubmitButton() {
        var $inputEmail = $('.form-unsub input[type="email"]');
        var $btn = $('.form-unsub .btn-primary');

        if ($inputEmail.val() == '') {
            $btn.attr('disabled', true);
        } else {
            $btn.attr('disabled', false);
        }
    }

	Global.FormUnsubscribeComponent = FormUnsubscribeComponent;

}(jQuery, window));